/* Movimiento E-com Project (v1.7.0): entradas al hacer scroll para las secciones de marca
   y escalonado en grillas. Solo anima lo que está bajo el primer pliegue (nada "parpadea"). */
(function () {
  var SEL = [
    '.fm-head', '.fm-feature', '.fm-step', '.fm-mile', '.fm-point', '.fm-tile', '.fm-ctile', '.fm-channel',
    '.fm-faq__item', '.fm-quote', '.fm-cta', '.fm-split__media', '.fm-split__content', '.fm-media', '.fm-aside',
    '.fm-phero__content', '.fm-rte', '.fm-form',
    '.section-header', '.section-heading', '.category-card', '.featured-category-card', '.collection-card',
    '.icon-feature-item', '.blog-card', '.review-card', '.faq-item', '.help-center-item'
  ].join(',');
  var ZOOM = '.fm-split__media, .fm-media, .fm-cta__media';

  function run(root) {
    var body = document.body;
    if (!body || body.getAttribute('data-scroll-animations') === 'disabled') return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    var vh = window.innerHeight || 800;
    var els = (root || document).querySelectorAll(SEL);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    var groups = new Map();
    Array.prototype.forEach.call(els, function (el) {
      if (el.classList.contains('ep-in') || el.closest('.ep-in, .reveal-on-scroll, .reveal-container-on-scroll, #shopify-section-header, .site-header, .cart-drawer-container, .megamenu-dropdown, .search-modal')) return;
      if (el.getBoundingClientRect().top < vh * 0.92) return; /* ya visible al cargar: sin animación */
      var parent = el.parentElement;
      var i = groups.get(parent) || 0;
      groups.set(parent, i + 1);
      el.style.setProperty('--delay', Math.min(i, 5) * 70 + 'ms');
      el.classList.add('ep-in');
      if (el.matches(ZOOM)) el.classList.add('ep-in--zoom');
      io.observe(el);
    });
    /* Tarjetas de producto: escalonado por fila (usa la aparición del tema) */
    var cards = (root || document).querySelectorAll('.product-card-item.reveal-container-on-scroll');
    var byParent = new Map();
    Array.prototype.forEach.call(cards, function (c) {
      var host = c.closest('.swiper-wrapper, [class*="grid"], ul, .collection-products-grid') || c.parentElement;
      var n = byParent.get(host) || 0;
      byParent.set(host, n + 1);
      c.style.setProperty('--delay', (n % 4) * 70 + 'ms');
    });
  }
  /* Red de seguridad: si algo quedó oculto y ya está en pantalla (scroll muy rápido, anclas), se muestra */
  var ticking = false;
  function sweep() {
    ticking = false;
    var vh = window.innerHeight || 800;
    document.querySelectorAll('.ep-in:not(.is-in), .reveal-container-on-scroll:not(.is-visible), .reveal-on-scroll:not(.is-visible)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) el.classList.add(el.classList.contains('ep-in') ? 'is-in' : 'is-visible');
    });
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; setTimeout(sweep, 250); } }, { passive: true });
  window.addEventListener('load', function () { setTimeout(sweep, 400); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); });
  else run();
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
